<div class="flex flex-col w-full gap-10">
  <div class="flex items-center justify-center">
    <span
      class="text-primary text-2xl border-[2px] border-transparent border-b-primary p-4"
    >
      Reset Password</span
    >
  </div>
  <form
    [formGroup]="resetPasswordForm"
    class="login-container gap-6 flex flex-col"
  >
    <div class="relative w-full">
      <span> New Passwrod</span>
      <!-- <app-text-input-tool placeholder="Enter Here"></app-text-input-tool> -->
      <input
        placeholder=""
        [type]="showPassword ? 'text' : 'password'"
        formControlName="newpassword"
        name="newpassword"
        class="w-full border p-2 rounded-md outline-none"
      />
      <img
        *ngIf="showPassword"
        (click)="showPassword = false"
        src="../../../assets/image/eye.svg"
        alt=""
        class="top-9 absolute right-2"
      />
      <img
        *ngIf="!showPassword"
        (click)="showPassword = true"
        src="../../../assets/image/closeeye.svg"
        alt=""
        class="absolute top-9 right-4"
      />
      <div
        *ngIf="
          resetPasswordForm.controls['newpassword'].touched &&
          !resetPasswordForm.controls['newpassword'].valid
        "
        class="text-red-500"
      >
        provide strong password ([1-9][#-$][A-Z])
      </div>
    </div>

    <div class="relative w-full">
      <span>Re-Enter Password</span>
      <!-- <app-text-input-tool placeholder="Enter Here"></app-text-input-tool> -->
      <input
        placeholder="**************"
        [type]="reEnterPassword ? 'text' : 'password'"
        formControlName="confirmpassword"
        name="confirmpassword"
        class="w-full border p-2 rounded-md outline-none"
      />
      <img
        *ngIf="reEnterPassword"
        (click)="reEnterPassword = false"
        src="../../../assets/image/eye.svg"
        alt=""
        class="top-9 absolute right-2"
      />
      <img
        *ngIf="!reEnterPassword"
        (click)="reEnterPassword = true"
        src="../../../assets/image/closeeye.svg"
        alt=""
        class="absolute top-9 right-4"
      />
      <div
        *ngIf="
          resetPasswordForm.controls['confirmpassword'].touched &&
          !resetPasswordForm.controls['confirmpassword'].valid
        "
        class="text-red-500"
      >
        Password does not match
      </div>
    </div>
  </form>
  <div class="items-center justify-center flex">
    <!-- <app-primary-button routerLink="/user-verification"> -->
    <app-primary-button (click)="confirmResetPassword()">
      <div class="gap-2 flex items-center">
        <img src="../../assets/image/Shape.png" alt="" class="h-4" />
        Confirm
      </div>
    </app-primary-button>
  </div>
</div>
